/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import ConfirmationPopUp from "../common/ConfirmationPopUp";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../loader/loader";
import ListDatatable from "./listdatatable";
import { getTradeHistory } from "../../reducers/adminReducers";
import NoDataFound from "../Generik/NoDataFound";
const TradeHistory = () => {
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { tradeHistory } = result || {};
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [loading, setLoading] = useState(false);
  const getTradeData = async () => {
    setLoading(true);
    const response = await dispatch(getTradeHistory());
    if (response?.payload) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getTradeData();
  }, []);


  const onCloseModal = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Breadcrumb title="Trade History" parent="Trade" />
      <Container fluid={true}>
        <div className="admin-card">
          <Card>
            <CardHeader>
              <h5>Trade History</h5>
            </CardHeader>
            <CardBody>
              <div className="btn-popup pull-right"></div>
              <div className="clearfix"></div>
              <div
                id="batchDelete"
                className="category-table user-list order-table coupon-list-delete deposit-table">
                {!loading ? (
                  tradeHistory.length > 0 ? (
                    <ListDatatable
                      multiSelectOption={true}
                      myData={tradeHistory}
                      pageSize={10}
                      pagination={true}
                      class="-striped -highlight"
                      setActiveId={setActiveId}
                      setOpen={setOpen}
                    />
                  ) : (
                    <NoDataFound data="Trade History" />
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
      <ConfirmationPopUp
        open={open}
        onCloseModal={onCloseModal}
        id={activeId}
      />
    </Fragment>
  );
};
export default TradeHistory;
